import { openExternalLink } from '../shared/helpers/linkHelpers';
import { InterruptionEmployeeResponseStatus } from '../types';
import InterruptionListCardActions from './InterruptionListCardActions';
import { InterruptionCreatorField, InterruptionTypeField } from '../shared/field';
import InterruptionMessage from '../shared/field/InterruptionMessage';
import InterruptionListCardLayout from './layout/InterruptionListCardLayout';
import InterruptionListCardActionsLayout from './layout/InterruptionListCardActionsLayout';

type InterruptionListCardProps = {
  onUpdateStatus: (id: string, status: InterruptionEmployeeResponseStatus) => Promise<boolean>;
};

const InterruptionListCard = ({ onUpdateStatus }: InterruptionListCardProps) => {
  return (
    <InterruptionListCardLayout>
      <InterruptionTypeField />
      <InterruptionCreatorField onOpenChat={openExternalLink} />

      <InterruptionMessage />

      <InterruptionListCardActionsLayout>
        <InterruptionListCardActions onUpdateStatus={onUpdateStatus} />
      </InterruptionListCardActionsLayout>
    </InterruptionListCardLayout>
  );
};

export default InterruptionListCard;
